import axios from '../axios'
import constants from '../constants'

// const errMsg = 'Server is unavialable'

export const getProfile = token => (dispatch) => {
  axios.get('/admin/profile', { headers: { Authorization: token } }).then((response) => {
    dispatch({
      type: constants.PROFILE,
      payload: {
        profile: response.data.data,
        resStatus: true
      }
    })
  }).catch(() => {
    dispatch({
      type: constants.PROFILE,
      payload: {
        profile: {},
        resStatus: false
      }
    })
  })
}
